import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { useThemeChange } from "../../../../utils/themeChange";
import { useApi } from "../../../../hooks/api/useApi";

import { ARTIST } from "../../../../constants/api-constants";
import ArtistList from "../list/List";

const INITIAL_ARTIST_LIMIT = 20;
const { LIST_ARTISTS } = ARTIST;

const ExploreArtist = () => {
  const themeChange = useThemeChange();
  const { getAll } = useApi();
  const [artistLimit, setArtistLimit] = useState(INITIAL_ARTIST_LIMIT);
  const [searchText, setSearchText] = useState("");

  const artists = useQuery({
    queryKey: ["artists", artistLimit, searchText],
    queryFn: () =>
      getAll(LIST_ARTISTS, { name: searchText, limit: artistLimit }),
  });

  const handleMore = () => {
    setArtistLimit(artistLimit + INITIAL_ARTIST_LIMIT);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setSearchText(e.target.value);
  };

  return (
    <div className={themeChange.add("section")}>
      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12">
                <h1 className="text-center">Explore Artists</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="items_filter">
              <div
                className="row form-dark"
                id="form_quick_search"
                name="form_quick_search"
              >
                <div className="col">
                  <input
                    className="form-control"
                    id="search"
                    name="search"
                    onChange={onSearch}
                    placeholder="Artist name"
                    type="text"
                  />
                  <button id="btn-submit">
                    <i className="fa fa-search bg-color-secondary"></i>
                  </button>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ArtistList allArtists={artists?.data} loading={artists?.isLoading} />
        {artistLimit <= artists?.data?.length && (
          <div className="d-flex justify-content-center">
            <span className="btn-main lead" onClick={handleMore}>
              Load More
            </span>
          </div>
        )}
      </section>
    </div>
  );
};

export default ExploreArtist;
